const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速爆料',
    desc: '全网热点信号实时抓取，从事件发生到平台发布仅需数分钟，让你快人一步掌握最新明星黑料与网红八卦。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实审核',
    desc: '专业编辑团队人工核实每一条爆料内容，杜绝虚假信息和恶意谣言，确保51吃瓜爆料网的内容真实可靠。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容',
    desc: '累计收录超过10万条爆料内容，覆盖娱乐圈、直播圈、网红圈等多元领域，满足各类吃瓜群众的需求。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持Web、iOS、Android多端无缝同步，收藏、历史、推送跨设备共享，随时随地畅享吃瓜乐趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            为什么选择我们
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">51吃瓜网今日吃瓜资源的四大核心优势</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 hover:bg-background-200/30 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}